import { z } from "zod";

export const GeneralContentsContentTypeEnum = z.enum(['product', 'link', 'general']);
export type GeneralContentsContentType = z.infer<typeof GeneralContentsContentTypeEnum>

export const SecureGeneralContentsArgsSchema = z.object({
  contentType: GeneralContentsContentTypeEnum.describe('The content type of contents.'),
  query: z.string().optional().describe('The search query to filter from title and description. Default is empty string to show all contents.')
});

export const GeneralContentsArgsSchema = z.object({
  clientId: z.string(),
  contentType: GeneralContentsContentTypeEnum,
  page: z.number(),
  limit: z.number().optional(),
  query: z.string().optional(),
});

export const GeneralContentSchema = z.object({
  account_id: z.string(),
  action_titles: z.array(z.string()),
  action_urls: z.array(z.string()),
  content_type: GeneralContentsContentTypeEnum,
  created_at: z.string().optional(),
  description: z.string(),
  id: z.string().optional(),
  currency: z.string().nullable().optional(),
  price: z.number().nullable().optional(),
  thumbnail_url: z.string().nullable().optional(),
  image_urls: z.array(z.string()).nullable().optional(),
  title: z.string(),
  updated_at: z.string().optional(),
});

export const ClientGeneralContentSchema = z.object({
  content: z.object({
    account_id: z.string(),
    action_titles: z.array(z.string()),
    action_urls: z.array(z.string()),
    content_type: GeneralContentsContentTypeEnum,
    created_at: z.string().optional(),
    description: z.string(),
    id: z.string().optional(),
    currency: z.string().nullable().optional(),
    price: z.number().nullable().optional(),
    thumbnail_url: z.string().nullable().optional(),
    image_urls: z.array(z.string()).nullable().optional(),
    title: z.string(),
    updated_at: z.string().optional(),
  }),
  client_id: z.string().nullable().optional(),
});


export type GeneralContentSchemaType = z.infer<typeof GeneralContentSchema>;